module.exports = __webpack_public_path__ + "static/logo-793a34a81dac9c0e52f46f33a9da3d0b.png";